import React from 'react';
import Meyda from 'meyda';
import { useRef, useState } from 'react';

const AudioAnalyzer = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [diagnosis, setDiagnosis] = useState({ message: "Analiz için başlatın...", color: "#666" });
  const [liveStats, setLiveStats] = useState({ rms: 0, zcr: 0, maxRms: 0 });
  
  const audioContextRef = useRef(null);
  const analyzerRef = useRef(null);
  const maxRmsRef = useRef(0); // En yüksek ses şiddetini tutmak için

  const startAnalysis = async () => {
    try {
      maxRmsRef.current = 0; // Her yeni analizde sıfırla
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioContext.createMediaStreamSource(stream);
      audioContextRef.current = audioContext;

      const analyzer = Meyda.createMeydaAnalyzer({
        audioContext: audioContext,
        source: source,
        bufferSize: 1024,
        featureExtractors: ['rms', 'zcr', 'spectralCentroid'],
        callback: (f) => {
          // Anlık RMS değerini takip et
          if (f.rms > maxRmsRef.current) {
            maxRmsRef.current = f.rms;
          }

          setLiveStats({
            rms: f.rms,
            zcr: f.zcr,
            maxRms: maxRmsRef.current
          });

          // --- GELİŞMİŞ TEŞHİS MANTIĞI ---
          let msg = "✅ Çalışma Normal";
          let color = "#4CAF50";

          // 1. KRİTİK VURUNTU ANALİZİ (Videodaki sert darbeler için)
          // Eğer anlık ses şiddeti 0.07'yi geçerse ve ses 'bas' karakterliyse (zcr düşükse)
          if (maxRmsRef.current > 0.07) {
            if (f.zcr < 250) {
              msg = "🚨 KRİTİK VURUNTU: Amortisör, Yay veya Denge Taşı Arızası!";
              color = "#D32F2F";
            } 
            // Eğer ses şiddetli ama çok tizse (ıslık gibi)
            else if (f.zcr > 500) {
              msg = "⚠️ RULMAN ARZISI: Kazan veya Motor Rulmanı Sürtüyor!";
              color = "#FF9800";
            }
          } 
          // 2. DÜŞÜK ŞİDDETLİ SESLER
          else if (maxRmsRef.current > 0.02) {
            msg = "ℹ️ Cihaz Çalışıyor (Normal Seviye)";
            color = "#2196F3";
          }

          setDiagnosis({ message: msg, color: color });
        },
      });

      analyzer.start();
      analyzerRef.current = analyzer;
      setIsRecording(true);
    } catch (err) {
      // NotAllowedError: Kullanıcı izin vermedi veya tarayıcı/platform izin vermiyor
      if (err.name === 'NotAllowedError' || err.message?.includes('Permission denied') || err.message?.includes('Permission dismissed')) {
        alert("Mikrofon izni reddedildi. Lütfen tarayıcı ayarlarından mikrofon iznini aktif edip sayfayı yenileyiniz.");
      } else if (err.name === 'NotFoundError') {
        alert("Mikrofon bulunamadı. Cihazınızda mikrofon olduğundan emin olun.");
      } else if (err.name === 'NotReadableError') {
        alert("Mikrofon başka bir uygulama tarafından kullanılıyor. Lütfen diğer uygulamaları kapatıp tekrar deneyin.");
      } else {
        alert("Hata: Mikrofon erişimi sağlanamadı.");
      }
    }
  };

  const stopAnalysis = () => {
    if (analyzerRef.current) analyzerRef.current.stop();
    if (audioContextRef.current) audioContextRef.current.close();
    setIsRecording(false);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Akustik Arıza Dedektörü</h2>
      
      <div style={{ ...styles.card, backgroundColor: diagnosis.color }}>
        <div style={styles.diagnosisText}>{diagnosis.message}</div>
      </div>

      <div style={styles.dataGrid}>
        <div style={styles.dataItem}>
          <span style={styles.label}>Anlık Şiddet</span>
          <div style={styles.value}>{(liveStats.rms * 100).toFixed(1)}</div>
        </div>
        <div style={styles.dataItem}>
          <span style={styles.label}>En Yüksek Darbe</span>
          <div style={{...styles.value, color: liveStats.maxRms > 0.07 ? 'red' : 'black'}}>
            {(liveStats.maxRms * 100).toFixed(1)}
          </div>
        </div>
        <div style={styles.dataItem}>
          <span style={styles.label}>Ses Tipi (ZCR)</span>
          <div style={styles.value}>{Math.round(liveStats.zcr)}</div>
        </div>
      </div>

      <button 
        onClick={isRecording ? stopAnalysis : startAnalysis}
        style={{...styles.button, backgroundColor: isRecording ? '#333' : '#FF9800'}}
      >
        {isRecording ? "DURDUR" : "CİHAZI DİNLE"}
      </button>

      <div style={styles.footer}>
        * Darbe değeri 7.0 üzerine çıktığında sistem otomatik arıza uyarısı verir.
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '20px', maxWidth: '400px', margin: 'auto', fontFamily: 'Arial, sans-serif', backgroundColor: '#fff', borderRadius: '20px' },
  title: { textAlign: 'center', fontSize: '20px', color: '#444', marginBottom: '20px' },
  card: { padding: '30px 20px', borderRadius: '15px', color: '#fff', textAlign: 'center', minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', transition: 'all 0.4s ease' },
  diagnosisText: { fontSize: '18px', fontWeight: 'bold' },
  dataGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginBottom: '20px' },
  dataItem: { textAlign: 'center', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '10px' },
  label: { fontSize: '11px', color: '#888', display: 'block' },
  value: { fontSize: '16px', fontWeight: 'bold', color: '#333' },
  button: { width: '100%', padding: '18px', borderRadius: '12px', border: 'none', color: '#fff', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' },
  footer: { marginTop: '15px', fontSize: '12px', color: '#999', textAlign: 'center' }
};

export default AudioAnalyzer;